import React from 'react';
import './how-we-work.css';

const steps = [
  {
    number: '01',
    title: 'Discover',
    description:
      'We listen, ask the right questions and define what success should look like for your business.',
    detail: 'Goals · Users · Scope',
    icon: 'bx bx-conversation',
  },
  {
    number: '02',
    title: 'Plan',
    description:
      'We turn the idea into a clear roadmap with priorities, responsibilities and realistic milestones.',
    detail: 'Strategy · Structure · Timeline',
    icon: 'bx bx-map-alt',
  },
  {
    number: '03',
    title: 'Design & build',
    description:
      'We shape the experience, develop the solution and keep you involved through every important decision.',
    detail: 'UX/UI · Development · Feedback',
    icon: 'bx bx-code-block',
  },
  {
    number: '04',
    title: 'Launch & improve',
    description:
      'We test, launch and continue improving the solution with dependable support after delivery.',
    detail: 'Testing · Launch · Support',
    icon: 'bx bx-rocket',
  },
];

const HowWeWork = () => {
  return (
    <section className="how-work" id="how-we-work">
      <div className="how-work-inner">
        <header className="how-work-heading">
          <div>
            <span className="how-work-eyebrow">HOW WE WORK</span>
            <h2>A clear process. No unnecessary complexity.</h2>
          </div>
          <div className="how-work-intro">
            <p>
              From first conversation to long-term support, our process keeps
              every project focused, transparent and moving forward.
            </p>
            <a href="#contact">
              Start a conversation
              <i className="bx bx-right-arrow-alt" aria-hidden="true" />
            </a>
          </div>
        </header>

        <div className="how-work-steps">
          {steps.map((step, index) => (
            <article className="how-work-step" key={step.number}>
              <div className="how-work-step-top">
                <span className="how-work-number">{step.number}</span>
                <span className="how-work-icon" aria-hidden="true">
                  <i className={step.icon} />
                </span>
              </div>

              <div className="how-work-step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
                <span className="how-work-detail">{step.detail}</span>
              </div>

              {index < steps.length - 1 && (
                <span className="how-work-connector" aria-hidden="true">
                  <i className="bx bx-right-arrow-alt" />
                </span>
              )}
            </article>
          ))}
        </div>

        <div className="how-work-promise">
          <span>One partner from idea to launch</span>
          <strong>Clear communication at every stage.</strong>
          <p>You always know what we are doing, why we are doing it and what comes next.</p>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
